import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Constants } from '../../../helper/constants';
import * as moment from 'moment';

import { QuestionService } from '../../../services/question.service';
import { QuestionsModel } from '../../../viewmodels/questions.model';
import { Global } from '../../../../../app.global';
import { GlobalObservables } from '../../../../../app.global.observer';
import { QuestionsConst } from '../../../helper/questionConst';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit {
  @Input() question: QuestionsModel = new QuestionsModel();
  @Output() questionAnswered: EventEmitter<any> = new EventEmitter<any>();

  public constants = Constants;
  public questionsList: Array<QuestionsModel> = [];
  public reasonsIdList = [];
  public questionDate = new Date();
  individualQuestions = [];

  constructor(
    public global: Global,
    public globalObs: GlobalObservables,
    public questionServ: QuestionService,
    public questionConst: QuestionsConst
  ) {}

  ngOnInit() {
    if (this.isQuestionClass(this.questionConst.freeTextDateClass, this.question.questionClass)) {
      this.question.answerSelected = this.question.defaultAnswer
        ? moment(this.question.defaultAnswer).toDate()
        : null;
    }
  }

  setAnswersAsList() {
    if (!Array.isArray(this.question.answerSelected)) {
      this.question.answerSelected = [this.question.answerSelected];
    }
  }

  onQuestionAnswered(answer) {
    if (this.isQuestionClass(this.questionConst.freeTextDateClass, this.question.questionClass)) {
      const year = moment(answer).year();
      const month = moment(answer).month();
      const date = moment(answer).date();
      const utcDate = new Date(Date.UTC(year, month, date));
      answer = utcDate;
    }
    this.questionAnswered.emit({ answer });
  }

  onPressEnterTextField(event) {
    if (event.keyCode === 13) {
      this.onQuestionAnswered(event.target.value);
    }
  }

  getParseInt(value) {
    return parseInt(value.toString(), 10);
  }

  isAnswerSelected(answerId) {
    return this.question.answerSelected.indexOf(answerId) > -1;
  }

  getAnswersList(answerId) {
    if (this.isAnswerSelected(answerId)) {
      this.question.answerSelected.splice(this.question.answerSelected.indexOf(answerId), 1);
    } else {
      this.question.answerSelected.push(answerId);
    }
    return this.question.answerSelected;
  }

  isQuestionClass(questionClass, classId) {
    return this.global.questionClasses[classId] === questionClass;
  }
}
